import { formValueSelector } from 'redux-form';
import { stringToBoolean } from '../../single-choice/utils/selection';
import { AIRPORT_TRANSFER } from '../../products';
import { NoneOption } from '../components/utils';
const formSection = AIRPORT_TRANSFER.name;
export const getAvailability = form => state => {
  var _formData$cartBreakDo;
  const formData = formValueSelector(form)(state, formSection);
  return (_formData$cartBreakDo = formData === null || formData === void 0 ? void 0 : formData.cartBreakDown) !== null && _formData$cartBreakDo !== void 0 ? _formData$cartBreakDo : null;
};
export const getSelected = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  if (!formData || (formData === null || formData === void 0 ? void 0 : formData.value) === NoneOption) {
    return null;
  }
  return stringToBoolean(formData === null || formData === void 0 ? void 0 : formData.value);
};
export const getPrice = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  const totalPrice = formData ? formData.selectionTravelerExternalChoice.reduce((total, choice) => total + choice.price, 0) : null;
  return totalPrice;
};
export const getGraphQlSelection = name => ({
  form,
  state
}) => {
  const formData = formValueSelector(form)(state, name);
  const UiSelection = formData === null || formData === void 0 ? void 0 : formData.value;
  const productId = String(AIRPORT_TRANSFER.id);
  if (!productId || !UiSelection || UiSelection === NoneOption) {
    return null;
  }
  const selections = formData.selectionTravelerExternalChoice;
  return {
    productId,
    selectionTravelerExternalChoice: selections.map(selection => {
      return {
        travelerId: selection.travelerId,
        choiceId: selection.choiceId
      };
    })
  };
};
//# sourceMappingURL=selection.js.map